import FileDraftErrorsList from './FileDraftErrorsList';
import FileDraftsList from './FileDraftsList';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileDrafts = ({
  fileDraftsMap,
  fileDraftsErrorsMap,
  onRemove,
  allUploadsFailed
}) => {
  if (allUploadsFailed) {
    return /*#__PURE__*/_jsx(UIAlert, {
      use: "inline",
      type: "danger",
      className: "m-top-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputFilesV2.allUploadsFailed"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fileDraftsMap.size > 0 && /*#__PURE__*/_jsx(FileDraftsList, {
      fileDraftsMap: fileDraftsMap
    }), fileDraftsErrorsMap.size > 0 && /*#__PURE__*/_jsx(FileDraftErrorsList, {
      fileDraftsErrorsMap: fileDraftsErrorsMap,
      onRemove: onRemove
    })]
  });
};
export default FileDrafts;